import { offlineRetryModalActionTypes } from '@/components/modals/offlineRetryModal/Constants';

export function openOfflineRetryModal(actionCall: any) {
	return {
		type: offlineRetryModalActionTypes.OPEN_OFFLINE_RETRY_MODAL,
		payload: {
			actionCall,
		},
	};
}

export function closeOfflineRetryModal() {
	return {
		type: offlineRetryModalActionTypes.CLOSE_OFFLINE_RETRY_MODAL,
	};
}
